import commonPartShow from './commonPartShow.vue'
export default commonPartShow
